<template>
    <div class="footer rd-fragment rd-site-footer">
        <div class="desc-logos">
            <img v-for="(item, index) in friendLogoList" :key="index" :src="item.imageUrl" />
        </div>
        <div class="classify">
            <div class="classify-sub hide" :class="{ 'act': act1 }" @click="act1 = !act1">
                <h4 class="classify-sub-title arrow botArrow">Cassino</h4>
                <div class="classify-sub-list">
                    <div v-for="(item, index) in gameClassify" :key="index" class="classify-sub-item" @click="toCasino(item)">{{ item.categoryShowName }}</div>
                </div>
                <img class="icon-18" src="@/assets/footer/icon-18+.png" alt="">
            </div>
            <div class="classify-sub hide" :class="{ 'act': act2 }" @click="act2 = !act2">
                <h4 class="classify-sub-title arrow botArrow">Actividad</h4>
                <div class="classify-sub-list">
                    <div class="classify-sub-item" @click="onNavToByIsLogin({ url: '/vip' })">VIP</div>
                    <div class="classify-sub-item" @click="onNavTo({ url: '/Affiliate' })">Agente</div>
                </div>
            </div>
            <div class="classify-sub hide" :class="{ 'act': act3 }" @click="act3 = !act3">
                <h4 class="classify-sub-title arrow botArrow">Suporte</h4>
                <div class="classify-sub-list">
                    <div class="classify-sub-item" @click="onNavTo({ url: '/notification', type: 'get', params: { type: 0 } })">Servir</div>
                    <div class="classify-sub-item" @click="onNavTo({ url: '/notification', type: 'get', params: { type: 2 } })">Notificar</div>
                </div>
            </div>
        </div>
        <div class="desc">
            <img class="logo" :src="logoUrl" />
            <!-- <div class="desc-content">{{ sysConfig.explainDec }}</div> -->
            <div class="desc-content">
                <div>1. Este producto est¡ destinado a personas mayores de 18 anos y es solopara fines de entretenimiento.</div>
                <div>2. Este juego contiene compras dentro de la aplicación.</div>
                <div>3. El hecho de que un jugador juegue o gane en un juego de apuestassociales no significa que vaya a ganar en apuestas con dinero real yjuegos relacionados en el futuro.</div>
                <img class="icon-18" src="@/assets/footer/icon-18+.png" alt="">
            </div>
        </div>
        <div class="copyright">{{ sysConfig.copyright }}</div>
    </div>
</template>

<script>
import { Toast } from 'vant'
import { getFriendLogoList } from '@/api/home'
import { getGameClassify } from '@/api/game'
export default {
    name: 'Footer',
    data() {
        return {
            act1: false,
            act2: false,
            act3: false,
            pathAct: '',
            friendLogoList: [],
            gameClassify: []
        }
    },
    computed: {
        logoUrl() {
            return this.$store.getters.sysConfig?.homeLogoUrl
        },
        sysConfig() {
            return this.$store.getters.sysConfig || {}
        }
    },
    watch: {
        $route: {
            handler: function (to, from) {
                this.pathAct = this.$route.name
            },
            deep: true
        }
    },
    created() {
        this.pathAct = this.$route.name
        this.getFriendLogoList()
        this.getGameClassify()
    },
    methods: {
        getGameClassify() {
            getGameClassify().then(res => {
                const that = this
                if (res.code) return
                const D = res.result.filter(x => x.gameTitleIPage && x.gameTitleIPage.records && x.gameTitleIPage.records.length && x.gameCategoryType !== 'None')
                const obj1 = {
                    id: 'Popular',
                    activationImg: this.$themeImage('home.category.popular'),
                    unActivationImg: this.$themeImage('home.category.popular'),
                    categoryShowName: this.$t('home.Popular'),
                    gameCategoryType: 'Popular',
                    favPageNum: 0,
                    favList: [],
                    RecentList: [],
                    hotPageNum: 1,
                    hotList: []
                }
                D.unshift(obj1)
                const obj2 = {
                    id: 'Recent',
                    activationImg: this.$themeImage('home.category.recent'),
                    unActivationImg: this.$themeImage('home.category.recent'),
                    categoryShowName: this.$t('home.Recent'),
                    gameCategoryType: 'Recente',
                    RecentPageNum: 0,
                    RecentList: []
                }
                D.push(obj2)
                const obj3 = {
                    id: 'Favoritos',
                    activationImg: this.$themeImage('home.category.favorite'),
                    unActivationImg: this.$themeImage('home.category.favorite'),
                    categoryShowName: this.$t('home.Favorite'),
                    gameCategoryType: 'Favoritos',
                    favPageNum: 0,
                    favList: []
                }
                D.push(obj3)
                that.gameClassify = D
            })
        },
        async getFriendLogoList(info, index) {
            const {
                result,
                code
            } = await getFriendLogoList()
            if (code === 0) {
                this.friendLogoList = result
            }
        },
        handleToTop(top) {
            const scrollEle = document.getElementById('AppMain') // Main scroll container
            scrollEle.scrollTo({
                top,
                behavior: 'smooth'
            })
        },
        onMenuItem(act) {
            if (this.pathAct === act) {
                Toast(this.$t('lang.CurrentlyPage'))
                return
            }
            this.pathAct = act
            this.onNavTo({ url: act, type: 'post' })
        },
        toCasino(item) {
            const obj = {
                iconImg: item.activationImg,
                code: item.gameCategoryType,
                title: item.gameCategoryType,
                gamePlatformType: item.gamePlatformType,
                // gameTitleId: item.id,
                gameFactoryName: item.gameFactoryName
            }
            // console.log(obj)
            const params = encodeURIComponent(JSON.stringify(obj))
            const timestamp = new Date().getTime()
            this.onNavTo({ url: 'SubGame', type: 'post', params: { timestamp, params } })
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/common/styles/viriables.scss';

.footer {
    margin: 0 1%;
    box-sizing: border-box;
    padding: 0 38px;
    padding-top: 35px;
    padding-bottom: 50px;
    overflow: hidden;
    background-image: var(--theme-footer-border-top), var(--theme-footer-border-body);
    background-size: 100% auto,100% 76%;
    background-position: top 0 left 0,bottom 0 left 0;
    background-repeat: no-repeat;
}
.desc-logos {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: .2rem;
    flex-wrap: wrap;
    padding-top: .32rem;

    & > img {
        height: .58rem;
        width: auto;
        vertical-align: middle;
        margin-bottom: .28rem;
    }
}
.classify {
    width: 100%;
    display: flex;
    margin: 0 auto;
    margin-top: .1rem;
    min-width: 720px;
    flex-wrap: wrap;
    // padding-left: 32px;
    // padding-right: 32px;

    .classify-sub {
        width: 33.33333%;
        margin-bottom: .5rem;

        &:first-child{
            width: 100%;
            padding-right: 88px;
            position: relative;
            .icon-18{
                position: absolute;
                right: 8px;
                bottom: 0;
                width: 68px;
                height: 68px;
            }
        }

        .classify-sub-title {
            width: 100%;
            color: var(--theme-footer-title-text);
            background: var(--theme-footer-menu-title-bg);
            text-transform: uppercase;
            margin-bottom: .28rem;
            text-align: left;
            font-size: .36rem;
            position: relative;
            padding: .2rem .24rem .2rem .34rem;

            &::before{
                content: '';
                width: .1rem;
                height: 82%;
                background-image: var(--theme-footer-menu-title-line);
                background-size: 100% 100%;
                position: absolute;
                left: 0;
                top: 10%;
            }
        }

        .classify-sub-list {
            font-size: 14px;
            text-align: left;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            padding-left: .26rem;
            background: var(--theme-footer-menu-list-bg);
            padding-top: .18rem;

            .classify-sub-item {
                color: var(--theme-footer-menu-link-text);
                line-height: .24rem;
                font-size: .35rem;
                margin-bottom: .32rem;
                cursor: pointer;
                transition: color .2s ease;
                margin-right: .8rem;

                &:hover,
                &.act {
                    color: var(--theme-bright-text);
                }
            }
        }
    }
}

.desc {
    flex: 1;
    text-align: left;
    width: 100%;
    margin: 0 auto;
    min-width: 720px;
    gap: .8rem;
    display: flex;
    align-items: center;

    .desc-content {
        color: var(--theme-footer-muted-text);
        font-size: .26rem;

        .icon-18{
            display: none;
        }
    }
    .logo {
        height: 1.3rem;
        width: auto;
        vertical-align: middle;
    }
}
.copyright {
    width: 100%;
    text-align: center;
    color: var(--theme-footer-copyright-text);
    font-size: .22rem;
    margin-top: .5rem;
}
</style>
